import { render, staticRenderFns } from "./QAgentContractingAgent.vue?vue&type=template&id=12fa7770&scoped=true&"
import script from "./QAgentContractingAgent.vue?vue&type=script&lang=js&"
export * from "./QAgentContractingAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa7770",
  null
  
)

export default component.exports